module.exports = __webpack_public_path__ + "static/media/portfolio-1.284dd2b8.jpg";